import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from './button';
import { useBackNavigation } from '../../hooks/use-back-navigation';

interface AppBarProps {
  title: string;
  onBack?: () => void;
  showBackButton?: boolean;
  className?: string;
  canGoBack?: boolean;
  showExitConfirmation?: boolean;
  children?: React.ReactNode;
}

export const AppBar: React.FC<AppBarProps> = ({
  title,
  onBack,
  showBackButton = true,
  className = '',
  canGoBack = true,
  showExitConfirmation = true,
  children
}) => {
  const { handleBack, isAndroid } = useBackNavigation({
    onBack,
    canGoBack,
    showExitConfirmation
  });

  return (
    <div className={`fixed top-0 left-0 right-0 z-50 border-b border-gray-200 shadow-sm rounded-b-2xl ${className}`} style={{ backgroundColor: '#0891b2' }}>
      <div className="flex items-center justify-between px-4 py-3 h-14">
        {/* Left side - Back button */}
        <div className="flex items-center">
          {showBackButton && (onBack || canGoBack) && (
            <Button
              variant="ghost"
              size="icon"
              onClick={handleBack}
              className="h-10 w-10 p-0 hover:bg-white/20 text-white back-button"
              data-back-button="true"
              aria-label="Go back"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
          )}
        </div>

        {/* Center - Title */}
        <div className="flex-1 flex justify-center">
          <h1 className="text-lg font-semibold text-white truncate max-w-[200px]">
            {title}
          </h1>
        </div>

        {/* Right side - Children or empty space for balance */}
        <div className={children ? 'flex items-center justify-end gap-1 flex-shrink-0 min-w-0' : 'w-10 flex items-center justify-center'}>
          {children}
        </div>
      </div>
    </div>
  );
};
